/**
 * About 1028 — BDU About Us
 * Square image, title with a gradient rule, justified body and a gradient-text link.
 */

export const ABOUT_1028_CONSTANTS = {
  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "About Us",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "About Us",
      defaultValue: "About Us",
    },
    {
      fieldName: "title_text_color",
      label: "Title colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Body copy (line breaks are preserved)",
      defaultValue: "",
      rows: 8,
    },
    {
      fieldName: "description_text_color",
      label: "Description colour",
      value: "#4F4F4F",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#4F4F4F",
    },
    {
      fieldName: "desktop_image",
      label: "Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Square image (363x363)",
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image alt",
      value: "About Us",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "About Us",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under title — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under title — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "is_cta",
      label: "Show the link",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "read_more_text",
      label: "Link label",
      value: "Know More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Know More",
      defaultValue: "Know More",
    },
    {
      fieldName: "cta_link",
      label: "Link URL",
      value: "/about-us",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/about-us",
      defaultValue: "/about-us",
    },
    {
      fieldName: "gradient_color_3",
      label: "Link gradient — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_4",
      label: "Link gradient — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
